var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_446_688",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_446_688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16669 14.1668H5.83335C4.68058 14.1668 3.69808 13.7604 2.88585 12.9477C2.07308 12.1354 1.66669 11.1529 1.66669 10.0002C1.66669 8.84738 2.07308 7.86461 2.88585 7.05183C3.69808 6.23961 4.68058 5.8335 5.83335 5.8335H9.16669V7.50016H5.83335C5.13891 7.50016 4.54863 7.74322 4.06252 8.22933C3.57641 8.71544 3.33335 9.30572 3.33335 10.0002C3.33335 10.6946 3.57641 11.2849 4.06252 11.771C4.54863 12.2571 5.13891 12.5002 5.83335 12.5002H9.16669V14.1668ZM6.66669 10.8335V9.16683H13.3334V10.8335H6.66669ZM10.8334 14.1668V12.5002H14.1667C14.8611 12.5002 15.4514 12.2571 15.9375 11.771C16.4236 11.2849 16.6667 10.6946 16.6667 10.0002C16.6667 9.30572 16.4236 8.71544 15.9375 8.22933C15.4514 7.74322 14.8611 7.50016 14.1667 7.50016H10.8334V5.8335H14.1667C15.3195 5.8335 16.3022 6.23961 17.115 7.05183C17.9272 7.86461 18.3334 8.84738 18.3334 10.0002C18.3334 11.1529 17.9272 12.1354 17.115 12.9477C16.3022 13.7604 15.3195 14.1668 14.1667 14.1668H10.8334Z",
    fill: "#00BCE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic-link.334f92759ae6539c685a1f984e6bc941.svg";
export { ForwardRef as ReactComponent };